import { Component, Input } from '@angular/core';

@Component({
  selector: 'frodo-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent {
  @Input() alt: string;
  @Input() src: string;
}
